
let timeoutId = null;
const EVENT_QUEUE = [];

const scheduleFlush = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  if (EVENT_QUEUE.length >= 10) {
    flushQueue();
  } else {
    timeoutId = setTimeout(() => flushQueue(), 15000); // 15 seconds
  }
};

export function trackEvent(eventName, payload) {
  EVENT_QUEUE.push({ event: eventName, payload, timestamp: new Date().toISOString() });

  // Save to sessionStorage as a transient ring buffer up to 50 items
  try {
     let sessionBuffer = JSON.parse(sessionStorage.getItem('telemetry_buffer') || '[]');
     sessionBuffer.push({ event: eventName, payload, timestamp: new Date().toISOString() });
     if (sessionBuffer.length > 50) {
        sessionBuffer = sessionBuffer.slice(sessionBuffer.length - 50);
     }
     sessionStorage.setItem('telemetry_buffer', JSON.stringify(sessionBuffer));
  } catch (e) {
     // sessionStorage is unavailable in private mode / when quota is exhausted.
     // Telemetry must never break the caller, so drop the buffer write only.
     console.debug('Telemetry ring buffer write skipped:', e?.message || e);
  }

  scheduleFlush();
}

const flushQueue = async () => {
  let sessionBuffer = [];
  try {
      sessionBuffer = JSON.parse(sessionStorage.getItem('telemetry_buffer') || '[]');
  } catch (e) {
      // Corrupt or inaccessible buffer: start from an empty queue rather than
      // dropping the in-memory events that are about to be flushed.
      console.debug('Telemetry ring buffer unreadable, flushing memory queue only:', e?.message || e);
      sessionBuffer = [];
  }

  if (EVENT_QUEUE.length === 0 && sessionBuffer.length === 0) return;

  // Combine memory queue and session buffer
  const combined = [...EVENT_QUEUE];
  for (const item of sessionBuffer) {
      if (!combined.some(e => JSON.stringify(e) === JSON.stringify(item))) {
          combined.push(item);
      }
  }

  EVENT_QUEUE.length = 0;

  try {
    const workerUrl = import.meta.env.VITE_EDGE_WORKER_URL || import.meta.env.VITE_ONYX_WORKER_URL || '';
    if (!workerUrl) return;

    const data = JSON.stringify(combined);
    const url = `${workerUrl}/api/v1/telemetry/event`;

    let success = false;
    try {
      if (navigator.sendBeacon) {
        success = navigator.sendBeacon(url, data);
      } else {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: data,
          keepalive: true
        });
        success = res.ok || res.status === 202;
      }

      if (success) {
         sessionStorage.removeItem('telemetry_buffer');
      }
    } catch (e) {
      console.debug("Telemetry batch send failed, caught to prevent blocking:", e);
    }
  } catch (e) {
    console.debug("Telemetry flush error", e);
  }
};

export function trackMetric(metricName, value, tags = {}) {
  trackEvent('metric', { name: metricName, value, tags });
}

export function logError(error, context = {}) {
  trackEvent('error', {
    message: error?.message || String(error),
    stack: error?.stack,
    context
  });
}

export function trackAiTelemetry({ ticketId, actionType, latencyMs, modelProvider, promptTokens, completionTokens, isCurated, metadata }) {
  trackEvent('ai_telemetry', {
    ticket_id: ticketId,
    action_type: actionType,
    latency_ms: latencyMs,
    model_provider: modelProvider,
    prompt_tokens: promptTokens,
    completion_tokens: completionTokens,
    is_curated: isCurated,
    metadata
  });
}
